import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

// import style


import i18n from '@/libs/i18n'
import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

//Lottie Animation
// import LottieAnimation from 'lottie-vuejs' // import lottie-vuejs

// 3rd party plugins
import '@axios'
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/slider'
import '@/libs/clipboard'
import '@/libs/jsoneditor'
import '@/libs/bootstrap-icons'
import VueObserveVisibility from 'vue-observe-visibility'

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

Vue.use(VueObserveVisibility)


// Composition API
Vue.use(VueCompositionAPI)

//Lottie Animations
// Vue.use(LottieAnimation); // add lottie-animation to your global scope

if (location.protocol === 'https:') {
  console.log = function() {}
  console.trace = function() {}
  window.log = function() {}
} else {
  window.log = function(itm){
    if (typeof itm == 'object'){
      itm = JSON.stringify(itm)
    }
    console.log(itm)
  }
}

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

//Feather Icons: https://demos.pixinvent.com/vuexy-vuejs-admin-template-vue2/demo-1/ui/feather

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

export default new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')